// Match the switch-back row only while the user is typing a query for its label (never on an empty query).
export const matchesRovoSwitchBackQuery = (query: string, label: string): boolean => {
	const q = query.trim().toLowerCase();
	return q.length > 0 && label.toLowerCase().includes(q);
};
